<template>
    <div>
        <ImprimBookTopHeader
            @show-forgot-password-modal="openForgotPasswordModal"
        />
        <div id="imprimbook-header">
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { inAdministrationSection, inSelfPublishingFlow } from "@/helpers/section";
import ImprimBookTopHeader from "@/components/Hermes/Header/CustomHeader/ImprimBookHeader/ImprimBookTopHeader";

export default {
    name: "ImprimBookHeader",
    components: {ImprimBookTopHeader },
    computed: {
        ...mapGetters("user", {
            user: "user",
            isUserLogged: "isLogged",
            userCart: "cart",
        }),
        inAdministrationSection() {
            return inAdministrationSection(this.$route.name);
        },
    },
    methods: {
        inSelfPublishingFlow,
        openForgotPasswordModal() {
            // Uses Bootstrap’s jQuery modal if available
            const el = document.getElementById("forgot-password-modal");
            if (!el) {
                return;
            }

            if (window.$ && window.$.fn && window.$.fn.modal) {
                window.$(el).modal("show");
            } else {
                // graceful fallback
                el.classList.add("show");
                el.style.display = "block";
                el.removeAttribute("aria-hidden");
            }
        },
    },
};
</script>

<style lang="scss" scoped>
    #imprimbook-header {
        background-color: #242021 !important;
        height: 100%;
        width: 100%;
    }

    ul {
        li {
            text-align: center;
            max-width: 150px;
        }
    }
</style>